import React, { useEffect, useState, useCallback } from 'react';
import useAuth from '@hooks/useAuth';
import { capitalizeName } from '@utils/commons';
import { editProfile } from '@api/profile';
import { ApiResponse } from '@typings/ApiResponse';
import { ProfileData } from '@typings/ProfileTypes';
import UploadImage from '@components/upload-image';
import IntroVideoThumb from '@assets/images/intro-video-2.png';
import { useNavigate } from 'react-router-dom';
import VideoPlayer from '../../video-player';

import './styles.scss';

const videoSrc1 =
  'https://www.youtube.com/embed/OZIr7iSIxTE?si=2E_l42zJRQWTIYl3';

const ProfileDetails: React.FC = () => {
  const { profile } = useAuth();
  const [currentAvatar, setCurrentAvatar] = useState('');
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [hasNewAvatar, setHasNewAvatar] = useState<boolean>(false);

  const navigate = useNavigate();

  function getGreeting() {
    const hour = new Date().getHours(); // 0-23

    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  }

  useEffect(() => {
    if (profile) {
      setCurrentAvatar(profile.avatar || '');
    }
  }, [profile]);

  const handleEditProfile = useCallback(async () => {
    setIsUploading(true);
    try {
      const response: ApiResponse<ProfileData> = await editProfile(
        profile?.id,
        currentAvatar
      );
      if (response && response.status === 'success') {
        // message.success(`Edit profile successfully!`);
        setHasNewAvatar(false); // Reset flag after successful profile edit
      } else {
        throw new Error(response.user_message || 'Failed to edit profile.');
      }
    } catch (error: any) {
      // message.error(`${error ? error?.message : 'Failed to edit profile.'}`);
    } finally {
      setIsUploading(false);
    }
  }, [profile?.id, currentAvatar]);

  useEffect(() => {
    if (hasNewAvatar) {
      handleEditProfile();
    }
  }, [currentAvatar, handleEditProfile, hasNewAvatar]);

  return (
    <div className="mt-3 profile-details">
      <h1 className="govuk-heading-l underline">
        {getGreeting()}{' '}
        {capitalizeName(profile?.full_name?.trim().split(' ')[0] || '')}
      </h1>
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-one-third">
          <div className="w-fit">
            <UploadImage
              isEditable
              isCustomized
              title=""
              imageUrl={currentAvatar}
              setImageUrl={(newUrl: string) => {
                setCurrentAvatar(newUrl);
                setHasNewAvatar(true);
              }}
            />
            <div
              className="-mt-2 govuk-bp:-mt-5 w-full text-center"
              onClick={() => navigate('/account')}
            >
              <p className="govuk-body govuk-!-static-margin-0">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" className="govuk-link govuk-link--no-visited-state">
                  Account settings
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="govuk-grid-column-two-thirds">
          <VideoPlayer videoSrc={videoSrc1} coverImage={IntroVideoThumb} />
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;
